/**
 * Hook to access user authentication state from Django
 * User data is set in base.html template via window.__SAGE_USER__
 */
export const useUser = () => {
  const userData = typeof window !== 'undefined' ? window.__SAGE_USER__ : null;

  return {
    isAuthenticated: userData?.isAuthenticated || false,
    user: userData?.isAuthenticated ? {
      id: userData.id,
      email: userData.email,
    } : null,
  };
};

export default useUser;